module.exports = __webpack_public_path__ + "img/notros-footer.fbadcdc6.svg";